// Backend column sorting for the admin Notifications Terminal grid
// (gated by SF_FEATURE_FLAG_BACKEND_COLUMN_SORTING).
//
// Every displayed column is backend-sortable. The User ID column sorts by
// COALESCE(user_id, admin_user_id); User Name / Account ID / Company Name sort
// against the associated users/admin_users/accounts on the backend. The dotted
// dataFields for Account ID / Company Name are the exact `sort_column` values
// the backend whitelists (they double as the row value accessors).
export const NOTIFICATIONS_TERMINAL_DEFAULT_SORT_COLUMN = 'created_at'
export const NOTIFICATIONS_TERMINAL_DEFAULT_SORT_DIRECTION = 'desc'
export const NOTIFICATIONS_TERMINAL_BACKEND_SORTABLE_COLUMNS = [
  'status',
  'user_id',
  'user_name',
  'user[accounts][0][id]',
  'user[accounts][0][company_name]',
  'banner_type',
  'message',
  'created_at',
]

export const isNotificationsTerminalColumnBackendSortable = (dataField) =>
  NOTIFICATIONS_TERMINAL_BACKEND_SORTABLE_COLUMNS.includes(dataField)

// Mutates and returns queryParams with the validated sort_column/sort_direction
// the backend expects. No-ops when backend sorting is disabled; unsupported
// columns fall back to the default so the API only ever receives a whitelisted
// value.
export const applyNotificationsTerminalSortParams = (queryParams, sortState, backendSortingEnabled) => {
  if (!backendSortingEnabled) {
    return queryParams
  }
  queryParams.sort_column = isNotificationsTerminalColumnBackendSortable(sortState?.column)
    ? sortState.column
    : NOTIFICATIONS_TERMINAL_DEFAULT_SORT_COLUMN
  queryParams.sort_direction = sortState?.direction || NOTIFICATIONS_TERMINAL_DEFAULT_SORT_DIRECTION
  return queryParams
}

export const buildNotificationsTerminalExportParams = (sortState, backendSortingEnabled) =>
  applyNotificationsTerminalSortParams({}, sortState, backendSortingEnabled)
